import { render, staticRenderFns } from "./Auth_Screen_RegistrationEmailSent.vue?vue&type=template&id=5ba1e002&scoped=true&"
import script from "./Auth_Screen_RegistrationEmailSent.vue?vue&type=script&lang=js&"
export * from "./Auth_Screen_RegistrationEmailSent.vue?vue&type=script&lang=js&"
import style0 from "./Auth_Screen_RegistrationEmailSent.vue?vue&type=style&index=0&id=5ba1e002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba1e002",
  null
  
)

export default component.exports